"use client";

import { useEffect, useState } from "react";

export type link = {
  label: string;
  href?: string;
};

export type footerlinks = {
  section: string;
  links: link[];
};
const Footer = () => {
  const [footerlinks, setFooterLinks] = useState<footerlinks[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch("/api/data");
        if (!res.ok) throw new Error("Failed to fetch");
        const data = await res.json();
        setFooterLinks(data.FooterLinksData);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="bg-black" id="first-section">
      <div className="container mx-auto max-w-2xl pt-16 pb-10 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="grid grid-cols-1 gap-y-8 gap-x-12 sm:grid-cols-2 lg:grid-cols-12 xl:gap-x-8">
          {/* COLUMN-1 */}
          <div className="col-span-4">
            <h4 className="text-white text-3xl leading-9 mb-4 lg:mb-20">
              Atlasimex 3D Previewer
            </h4>
            <div className="flex items-center gap-4">
              <div className="footer-icons">
                <a href="https://facebook.com">
                  <img
                    src={"/images/footer/vec.svg"}
                    alt="facebook"
                    width={15}
                    height={20}
                  />
                </a>
              </div>
              <div className="footer-icons">
                <a href="https://twitter.com">
                  <img
                    src={"/images/footer/twitter.svg"}
                    alt="twitter"
                    width={25}
                    height={20}
                  />
                </a>
              </div>
              <div className="footer-icons">
                <a href="https://instagram.com">
                  <img
                    src={"/images/footer/instagram.svg"}
                    alt="instagram"
                    width={25}
                    height={20}
                  />
                </a>
              </div>
            </div>
          </div>
          {/* CLOUMN-2/3 */}
          {footerlinks.map((item, i) => (
            <div key={i} className="group relative col-span-2">
              <p className="text-white text-xl font-extrabold mb-9">
                {item.section}
              </p>
              <ul>
                {item.links.map((item, i) => (
                  <li key={i} className="mb-5">
                    <a
                      href={`${item.href}`}
                      className="text-white text-lg font-normal mb-6 space-links hover:text-white/60 hover:underline"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      {/* All Rights Reserved */}
      <div className="mx-auto max-w-2xl lg:max-w-7xl">
        <div className="pt-4 pb-4 px-4 sm:px-6 lg:px-4 border-t border-white/20">
          <div className="mt-2 grid grid-cols-1 gap-y-6 gap-x-12 sm:grid-cols-2 xl:gap-x-8">
            <div>
              <p className="text-center md:text-start text-white text-lg">
                <>
                  @{new Date().getFullYear()} - All Rights Reserved by{" "}
                  <a
                    href="https://atlasimex.es"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-white/60 hover:underline"
                  >
                    Atlasimex 3D Previewer
                  </a>
                </>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
